export default __webpack_public_path__ + "static/electron-logo-52c972769a02bea22327324f03b6c1be.svg";